import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/authContext";
import AuthLoadingScreen from "@/components/AuthLoadingScreen";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <AuthLoadingScreen />;
  }

  if (!user) return <Navigate to="/auth" replace />;
  return <>{children}</>;
}
